import {twMerge} from '../../../common/twMerge';
import {BADGE_TYPE_TO_ICON_TYPE_MAP} from '../../atoms/Icon/constants';
import {Icon} from '../../atoms/Icon/Icon';
import {Image} from '../../atoms/Image/Image';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {LabelBadge} from '../LabelBadge/LabelBadge';
import {LabelBadge16Type} from '../LabelBadge/LabelBadge16Type.enum';
import {LabelBadgeSizeType} from '../LabelBadge/LabelBadgeSizeType.enum';
import {ThumbnailRatio} from './ThumbnailRatio.constant';
import {ThumbnailWithBadgesProps} from './ThumbnailWithBadgesProps.interface';

export function ThumbnailWithBadges({
  thumbnail,
  thumbnailType,
  badgeList,
  extraInfoIcon,
  ageGradeBadge,
  isAgeRestricted,
  imageLazyLoad = true,
  className,
  borderRadius = 8,
  discountRateText,
  ...props
}: ThumbnailWithBadgesProps) {
  const badgeArr = badgeList
    ? Array.isArray(badgeList)
      ? badgeList
      : [badgeList]
    : undefined;

  return (
    <div
      className={twMerge('relative overflow-hidden', className)}
      {...props}
      style={{
        borderRadius: `${borderRadius}px`,
      }}
    >
      {isAgeRestricted && (
        <>
          <StaticImage imageType={StaticImageType.Age19Thumbnail43} />
        </>
      )}
      {!isAgeRestricted && (
        <>
          <Image
            src={thumbnail}
            alt="썸네일"
            className="h-full w-full"
            ratio={ThumbnailRatio[thumbnailType]}
            isLazy={imageLazyLoad}
          />
          <div className="absolute left-0 top-0 ml-4pxr mt-4pxr flex gap-2pxr">
            {discountRateText && (
              <LabelBadge
                sizeType={LabelBadgeSizeType.Size16}
                type={LabelBadge16Type.red}
                label={discountRateText}
              />
            )}
          </div>
          {badgeArr && (
            <div className="absolute left-0 top-0 ml-4pxr mt-4pxr flex">
              {badgeArr.map((badge, idx) => (
                <Icon
                  className={twMerge('ml-2pxr shrink-0', idx === 0 && 'ml-0')}
                  key={`${badge}_${idx}`}
                  type={BADGE_TYPE_TO_ICON_TYPE_MAP[badge]}
                />
              ))}
            </div>
          )}
          {ageGradeBadge && (
            <div className="absolute right-0 top-0 mr-4pxr mt-4pxr">
              <Icon
                className="shrink-0"
                type={BADGE_TYPE_TO_ICON_TYPE_MAP[ageGradeBadge]}
              />
            </div>
          )}
          {extraInfoIcon && (
            <div className="absolute bottom-0 right-0 mb-4pxr mr-4pxr">
              <Icon className="shrink-0" type={extraInfoIcon} />
            </div>
          )}
        </>
      )}
      {/* 썸네일 보더 */}
      <div
        className="absolute left-0 top-0 h-full w-full border-[0.5px] border-solid border-static-transparent-black-05"
        style={{
          borderRadius: `${borderRadius}px`,
        }}
      />
    </div>
  );
}
